module.exports = __webpack_public_path__ + "static/img/logo(2).b309e4a4.jpg";